import { CustomProvider, DateRangePicker } from "rsuite";

import { IntlProvider } from "react-intl";
import csCZ from "rsuite/locales/cs_CZ";
import deDE from "rsuite/locales/de_DE";
import enGB from "rsuite/locales/en_GB";
import esES from "rsuite/locales/es_ES";
import frFR from "rsuite/locales/fr_FR";
import itIT from "rsuite/locales/it_IT";
import nlNL from "rsuite/locales/nl_NL";
import plPL from "rsuite/locales/pl_PL";
import lt from "../../utils/rsuiteLT";
import ro from "../../utils/rsuiteRO";

import { useTranslation } from "react-i18next";
import "rsuite/DateRangePicker/styles/index.css";
import { langCountryCodesDictionary } from "../../constants";

const localesDictionary = {
	at: deDE,
	be: nlNL,
	cz: csCZ,
	de: deDE,
	en: enGB,
	es: esES,
	fr: frFR,
	it: itIT,
	lt: lt, // custom, missing in rsuite
	nl: nlNL,
	pl: plPL,
	ro: ro, // custom, missing in rsuite
	sk: enGB,
};

export const StyledDateRangePicker = ({ value, onChange, error, ...rest }) => {
	const { t, i18n } = useTranslation();

	return (
		<IntlProvider locale={langCountryCodesDictionary[i18n.language] || "pl"}>
			<CustomProvider locale={localesDictionary[i18n.language] || plPL}>
				<DateRangePicker
					className={error ? "sb-input-error" : ""}
					isoWeek
					showOneCalendar
					showHeader={false}
					ranges={[]} // remove predefined ranges
					style={{ width: "100%" }}
					character=" - "
					value={value}
					onChange={onChange}
					format="dd/MM/yyyy"
					placeholder={t("from_to")}
					{...rest}
				/>
			</CustomProvider>
		</IntlProvider>
	);
};
